import React, { useState, useEffect } from 'react'
import {
  Panel,
  Button,
  Input,
  ControlLabel,
  Message,
  Modal,
  Row,
  Col,
  CheckboxGroup,
  Checkbox,
  SelectPicker,
  Cascader,
  Uploader,
  Icon,
  ButtonGroup,
  IconButton,
} from 'rsuite'
import { useHistory } from 'react-router-dom'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../../utils/loading'
import {
  isImageOrPdf,
  isRequired,
  isValidators,
  requiredFiled,
} from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import ConfirmWidget from '../../confirm/ConfirmWidget'
import {
  deleteRequestVendorFile,
  downRequestVendorFile,
  getRmsLocationDatas,
  getVenderRequestForm,
  saveRequestVendor,
  saveRequestVendorFile,
  updateWidthdrawRequestApprove,
} from '../../../redux/actions/withdrawRequest'
import pathname from '../../../constants/pathname'
import { sendFeedback } from '../../../redux/actions/projectProgress'
import { Link } from 'react-router-dom'
import CustomMessages from '../../../components/message/CustomMessages.js'
import ApproverList from '../../../components/modal/ApproverListModal/ApproverList.js'
import classNames from 'classnames'
import { cloneDeep, isEmpty } from 'lodash-es'
import notification from '../../../utils/notification.js'
import { SAVE_FAILED_MSG, SAVE_SUCCESS_MSG } from '../../../constants/msgText.js'
import { downloadFile, previewFile } from '../../../utils/fileUtil.js'
import { v4 as uuidv4 } from 'uuid'

export default function SendWithdrawRequestWidget(props) {
  const {
    schema,
    isWithdrawNotMatch,
    disableSendBack,
    disabledSendWithdraw,
    nowRequestNo,
    isWithdrawOver: _isWithdrawOver,
    isSaveWithdrawPlan: _isSaveWithdrawPlan,
    bankInformation: _bankInformation,
    requestId,
  } = props

  const { register, handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()

  const formVenderChange = useForm()
  const {
    register: register2,
    handleSubmit: handleSubmit2,
    errors: errors2,
    control: control2,
    setValue: setValue2,
    clearErrors: clearErrors2,
  } = formVenderChange

  const formVenderChangeFile = useForm()
  const {
    register: register3,
    handleSubmit: handleSubmit3,
    errors: errors3,
    control: control3,
    setValue: setValue3,
    clearErrors: clearErrors3,
  } = formVenderChangeFile

  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [memo, setMemo] = useState('')
  const [showConfirm, setShowConfirm] = useState(false)
  const [isWithdrawOver, setIsWithdrawOver] = useState(false)
  const [isSaveWithdrawPlan, setIsSaveWithdrawPlan] = useState(false)
  const [bankInformation, setBankInformation] = useState(false)
  const [showConfirmSendBack, setShowConfirmSendBack] = useState(false)
  const [vendorRequestSchema, setVendorRequestSchema] = useState()
  const [vendorRequestShowModal, setVendorRequestShowModal] = useState()
  const [rmsLocation, setRmsLocation] = useState()
  const [editTypeVal, setEditTypeVal] = useState()
  const [fileLists, setFileLists] = useState([])
  const [fileList2, setFileList2] = useState([])
  const [fileTypeError, setFileTypeError] = useState(false)
  const [filesImage, setFilesImage] = useState([])
  const [delFilesImage, setDelFilesImage] = useState([])
  const [FilesTables, setFilesTables] = useState([])
  const [FilesTablesEtc, setFilesTablesEtc] = useState([])
  const [vatRegistrationVal, setVatRegistrationVal] = useState('0')

  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()

  useEffect(() => {
    //console.log('_isWithdrawOver', _isWithdrawOver)
    setIsWithdrawOver(_isWithdrawOver)
  }, [_isWithdrawOver])

  useEffect(() => {
    //console.log('_isSaveWithdrawPlan', _isSaveWithdrawPlan)
    setIsSaveWithdrawPlan(_isSaveWithdrawPlan)
  }, [_isSaveWithdrawPlan])

  useEffect(() => {
    //console.log('_bankInformation', _bankInformation)
    setBankInformation(_bankInformation)
  }, [_bankInformation])

  // console.log('requestId in SendWithdrawRequestWidget', schema.requestId)

  useEffect(() => {
    handleGetVendorRequestSchema(projectId, schema.requestId)
  }, [projectId, schema.requestId])

  useEffect(() => {
    if (!vendorRequestSchema?.forms?.inputForm?.id) {
      setEditTypeVal(null)
      setVatRegistrationVal('0')
      setFilesTables([])
      setFilesTablesEtc([])
    } else {
      if (projectId && schema.requestId) {
        handleGetVendorRequestSchema(projectId, schema.requestId)
      }
    }
  }, [vendorRequestShowModal])

  const handleCallService = async () => {
    let request = {
      value: memo,
    }

    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const response = await updateWidthdrawRequestApprove(projectId, schema.requestId, request)
      console.log(response)
      if (response.isSuccess) {
        //success jump to new page
        setIsError(false)
        setShowConfirm(false)
        doneLoading()
        setIsLoading(false)
        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      } else {
        setIsError(response.message)
      }
    } catch (e) {
      console.log(e)
      if (e?.response?.data?.errorMessage) {
        setIsError(e.response.data.errorMessage)
      } else {
        let errorMessage = ''
        e?.response?.data?.errors?.message?.forEach((element) => {
          errorMessage = errorMessage.concat(element)
        })
        setIsError(errorMessage)
      }
    }
    doneLoading()
    setShowConfirm(false)
    setIsLoading(false)
  }

  const handleGetVendorRequestSchema = async (projectId, requestId) => {
    try {
      const resp = await getVenderRequestForm(projectId, requestId)
      console.log('resp => ', resp)
      if (resp) {
        setVendorRequestSchema(resp)
        setEditTypeVal(resp?.forms?.inputForm?.editType?.value)
        setVatRegistrationVal(resp?.forms?.inputForm?.vatRegistration?.value || '0')

        let newArr = []
        if (Array.isArray(resp?.forms?.fileCondition) && resp?.forms?.fileCondition.length > 0) {
          resp?.forms?.fileCondition?.map((item) => {
            if (item.attId) {
              newArr.push({
                id: item?.id,
                fileName: item?.fileName,
                fileType: item?.fileType,
                isRequired: item?.isRequired,
                requestType: item?.requestType,
                vatType: item?.vatType,
                attId: item?.attId,
                attFileName: item?.attFileName,
                attFilePath: item?.attFilePath,
                value: null,
              })
            }
          })

          setFilesTables(newArr)
        }
      }
    } catch (e) {
      console.log('error handleGetVendorRequestSchema ', e)
    }
  }

  const handleCallServiceSendBack = async () => {
    let request = {
      projectVersionId: projectId,
      //projectProgressId: progressId,
      note: memo,
    }

    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const response = await sendFeedback(projectId, schema.projectProgressId, request)
      console.log(response)
      if (response) {
        //success jump to new page
        setIsError(false)
        setShowConfirm(false)
        doneLoading()
        setIsLoading(false)
        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      } else {
        setIsError(response.message)
      }
    } catch (e) {
      console.log(e)
      if (e?.response?.data?.errorMessage) {
        setIsError(e.response.data.errorMessage)
      } else {
        let errorMessage = ''
        e?.response?.data?.errors?.message?.forEach((element) => {
          errorMessage = errorMessage.concat(element)
        })
        setIsError(errorMessage)
      }
    }
    doneLoading()
    setShowConfirm(false)
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    //console.log('data', data)
    setMemo(data.note)
    setShowConfirm(true)
  }

  const onSubmitSendBack = (data) => {
    //console.log('data', data)
    setMemo(data.note)
    setShowConfirmSendBack(true)
  }

  const handleOpenModalVendorRequest = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const resp = await getRmsLocationDatas()
      // console.log('resp handleOpenModalVendorRequest', resp)
      // console.log('vendorRequestSchema => ', vendorRequestSchema)
      setFilesTablesEtc()

      if (resp.success) {
        if (!vendorRequestSchema.forms.inputForm.editType.value) {
          setFilesTables(null)
          // setEditTypeVal('')
        }

        setRmsLocation(resp.model)
        setVendorRequestShowModal(true)
      }
    } catch (e) {
      console.log('error handleOpenModalVendorRequest ', e)
    }
    doneLoading()
    setIsLoading(false)
  }

  const checkFilesRequired = (files) => {
    // console.log('files gggg => ', files)

    if (!Array.isArray(files) || files.length === 0) {
      notification.open('error', {
        title: 'ไม่พบรายการไฟล์เอกสาร',
        duration: 5000,
      })
      return false
    }

    const missingRequiredFile = files.find((item) => {
      const hasUploadFiles = Array.isArray(item?.value?.files) && item.value.files.length > 0
      const hasAttachedFile = !!item?.attId

      return item?.isRequired === true && !hasUploadFiles && !hasAttachedFile
    })

    if (missingRequiredFile) {
      notification.open('error', {
        title: `กรุณาแนบไฟล์ ${missingRequiredFile.fileName}`,
        duration: 5000,
      })

      return false
    }

    return true
  }

  const onSubmitVendorRequest = async (data) => {
    const chkFile = checkFilesRequired(FilesTables)

    if (!chkFile) {
      return false
    }

    if (!editTypeVal || editTypeVal.length == 0) {
      let msg = vendorRequestSchema?.forms?.inputForm?.editType.validators?.find(
        (item) => item.type === 'REQUIRED'
      )

      setError2(vendorRequestSchema?.forms?.inputForm.editType.name, {
        type: 'manual',
        message: msg.errorMessage || 'กรุณาเลือกการทำรายการ',
      })

      return false
    }

    // if (filesImage.length == 0) {
    //   notification.open('error', {
    //     title: 'กรุณาแนบเอกสารประกอบ',
    //     duration: 5000,
    //   })
    //   return false
    // }

    // return false

    setIsLoading(true)
    startLoading()
    try {
      const formData = new FormData()
      formData.append('Id', vendorRequestSchema?.forms?.inputForm?.id || '')
      formData.append('StatusCode', 0)
      formData.append('EditType', editTypeVal ? editTypeVal.join(',') : '')
      formData.append('VatRegistration', data.vatRegistration || '')
      formData.append('Building', data.building || '')
      formData.append('FloorRoom', data.floorRoom || '')
      formData.append('AddressNumber', data.addressNumber || '')
      formData.append('Moo', data.moo || '')
      formData.append('Soi', data.soi || '')
      formData.append('Village', data.village || '')
      formData.append('Road', data.road || '')
      formData.append('Location', data.location || '')
      formData.append('EncpTaxId', vendorRequestSchema?.forms?.rmsMessageInfo?.encpTaxId || '')
      formData.append('VendorCode', vendorRequestSchema?.forms?.rmsMessageInfo?.vendorCode || '')
      formData.append('WithholdingTaxType', data.withholdingTaxType || '')

      let c = 0
      FilesTables &&
        FilesTables?.forEach((item) => {
          const files = item?.value?.files

          if (Array.isArray(files) && files.length > 0) {
            files.forEach((file) => {
              formData.append(`AttachFilesList[${c}].DocumentId`, item.attId)
              formData.append(`AttachFilesList[${c}].DocumentTypeId`, item.id)
              formData.append(`AttachFilesList[${c}].DocumentType`, item.fileType)
              formData.append(`AttachFilesList[${c}].AttachFiles`, file.blobFile)
              c += 1
            })
          }
        })

      // c = 0
      FilesTablesEtc &&
        FilesTablesEtc?.forEach((item) => {
          const files = item?.value?.files

          if (Array.isArray(files) && files.length > 0) {
            files.forEach((file) => {
              formData.append(`AttachFilesList[${c}].DocumentId`, item.attId)
              formData.append(`AttachFilesList[${c}].DocumentTypeId`, item.id)
              formData.append(`AttachFilesList[${c}].DocumentType`, item.fileType)
              formData.append(`AttachFilesList[${c}].AttachFiles`, file.blobFile)
              c += 1
            })
          }
        })
      // filesImage &&
      //   filesImage?.forEach((element) => {
      //     console.log('element => ', element)
      //     if (element.id === null) {
      //       formData.append(`AttachFilesList[${c}].DocumentTypeId`, element.documentType)
      //       formData.append(`AttachFilesList[${c}].AttachFiles`, element.attachfile)

      //       c += 1
      //     }
      //   })

      // fileList2 &&
      //   fileList2?.forEach((element) => {
      //     console.log('element => ', element)
      //     if (element.id === null) {
      //       formData.append(`AttachFilesList[${c}].DocumentTypeId`, element.documentType)
      //       formData.append(`AttachFilesList[${c}].AttachFiles`, element.attachfile)

      //       c += 1
      //     }
      //   })

      delFilesImage &&
        delFilesImage?.forEach((element) => {
          formData.append('DeleteFileIds', element)
        })

      const resp = await saveRequestVendor(projectId, requestId, formData, 'Save')
      // console.log('resp => ', resp)

      if (resp) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })

        setValue3(vendorRequestSchema?.forms?.attachFiles.name, [])
        setValue3(vendorRequestSchema?.forms?.attachFiles?.inputDocumentType?.name, '')
        setFileList2([])

        // setVendorRequestSchema(resp)
        handleGetVendorRequestSchema(projectId, schema.requestId)
        setVendorRequestShowModal(false)
      } else {
        notification.open('error', {
          title: SAVE_FAILED_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('error handleOpenModalVendorRequest ', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || SAVE_FAILED_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  // const onSubmitVendorRequestFile = async (data) => {
  //   console.log('onSubmitVendorRequestFile', data)

  //   const formData = new FormData()
  //   formData.append('DocumentTypeId', data?.documentType || '')

  //   data.attachfile &&
  //     data.attachfile?.forEach((element) => {
  //       formData.append('AttachFiles', element.blobFile)
  //     })

  //   handleVendorSaveFile(formData)
  // }
  const onSubmitVendorRequestFile = async (data) => {
    console.log('onSubmitVendorRequestFile', data)

    let documentTypeDesc =
      vendorRequestSchema?.forms?.attachFiles?.inputDocumentType?.options?.find(
        (item) => item.value === data.documentType
      )

    let newArr = cloneDeep(filesImage || [])

    newArr.push({
      id: null,
      vid: uuidv4(),
      documentType: data.documentType,
      documentTypeDesc: documentTypeDesc.label || '',
      fileName: data.attachfile[0]?.name || '',
      attachfile: data.attachfile[0]?.blobFile || null,
    })

    setValue3(vendorRequestSchema?.forms?.attachFiles.name, [])
    setValue3(vendorRequestSchema?.forms?.attachFiles?.inputDocumentType?.name, '')
    setFileList2([])

    setFilesImage(newArr)
  }

  const handleVendorSaveFile = async (request) => {
    startLoading()
    setIsLoading(true)

    try {
      let response = await saveRequestVendorFile(request, projectId, schema.requestId)
      // console.log('resssss => ', response)

      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })

        setValue3(vendorRequestSchema?.forms?.attachFiles.name, [])
        setValue3(vendorRequestSchema?.forms?.attachFiles?.inputDocumentType?.name, '')
        setFileList2([])

        handleGetVendorRequestSchema(projectId, schema.requestId)
      } else {
        notification.open('error', {
          title: SAVE_FAILED_MSG,
          duration: 5000,
        })
      }
    } catch (error) {
      console.log('error', error)
      notification.open('error', {
        title: SAVE_FAILED_MSG,
        duration: 5000,
      })
    }

    setIsLoading(false)
    doneLoading()
  }

  // const handlePreviewFile = async (fileObj) => {
  //   console.log('file => ', fileObj)

  //   startLoading()
  //   setIsLoading(true)
  //   try {
  //     var file = await downRequestVendorFile(fileObj?.id)
  //     var fileName = fileObj?.name || fileObj?.id

  //     previewFile(file, fileName)
  //   } catch (e) {
  //     console.log(e)
  //     notification.open('error', {
  //       title: 'แสดง ไม่สำเร็จ ',
  //       duration: 5000,
  //     })
  //   }
  //   doneLoading()
  //   setIsLoading(false)
  // }

  const handlePreviewFile = async (fileObj) => {
    console.log('file => ', fileObj)

    // return false

    startLoading()
    setIsLoading(true)

    try {
      // if (fileObj.id === null) {
      //   previewFile(fileObj.attachfile, fileObj.fileName)
      // } else {
      var file = await downRequestVendorFile(fileObj?.attId)

      // console.log(file)
      // return false

      var fileName = `${fileObj?.fileName || ''}_${fileObj?.attId || ''}`

      previewFile(file, fileName)
      // }
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'แสดง ไม่สำเร็จ ',
        duration: 5000,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleDownloadFile = async (fileObj) => {
    console.log('file => ', fileObj)

    setIsLoading(true)
    startLoading()

    try {
      // if (fileObj.id === null) {
      //   downloadFile(fileObj.attachfile, fileObj.fileName)
      // } else {
      var file = await downRequestVendorFile(fileObj.attId)
      var fileName = `${fileObj?.fileName || ''}_${fileObj?.attId || ''}`

      downloadFile(file, fileName)
      // }
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleDeleteFile = async (fileObj) => {
    console.log('handleDeleteFile => ', fileObj)

    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      let oldFiles = cloneDeep(FilesTables || [])

      let newArr = []
      if (oldFiles && oldFiles.length > 0) {
        oldFiles.map((item) => {
          console.log('item => ', item)
          // if (item.attId !== fileObj.attId) {
          // newArr.push(item)
          newArr.push({
            id: item?.id,
            fileName: item?.fileName,
            fileType: item?.fileType,
            isRequired: item?.isRequired,
            requestType: item?.requestType,
            vatType: item?.vatType,
            attId: item.attId === fileObj.attId ? null : item.attId,
            attFileName: item.attId === fileObj.attId ? null : item.attFileName,
            attFilePath: item.attId === fileObj.attId ? null : item.attFilePath,
            value: null,
          })
          // }
        })

        // console.log('newaaaa => ', newArr)
        // setFilesImage(newArr)
        setFilesTables(newArr)

        if (fileObj.attId !== null) {
          let delArr = cloneDeep(delFilesImage || [])
          delArr.push(fileObj.attId)
          setDelFilesImage(delArr)
        }
      }
    } catch (error) {
      console.log('error', error)
      notification.open('error', {
        title: 'ลบไม่สำเร็จ',
      })
    }

    setIsLoading(false)
    doneLoading()
  }

  const handleSendRequestEditVendorRequest = async (data) => {
    if (!editTypeVal || editTypeVal.length == 0) {
      // console.log('error editTypeVal ')
      let msg = vendorRequestSchema?.forms?.inputForm?.editType.validators?.find(
        (item) => item.type === 'REQUIRED'
      )

      setError2(vendorRequestSchema?.forms?.inputForm.editType.name, {
        type: 'manual',
        message: msg.errorMessage || 'กรุณาเลือกการทำรายการ',
      })

      return false
    }

    const chkFile = checkFilesRequired(FilesTables)

    if (!chkFile) {
      return false
    }

    // const chkFile = checkFilesRequired(FilesTables)
    // if (!chkFile) {
    //   notification.open('error', {
    //     title: 'กรุณาแนบเอกสารประกอบ',
    //     duration: 5000,
    //   })
    //   return false
    // }

    // return false

    setIsLoading(true)
    startLoading()
    try {
      const formData = new FormData()
      formData.append('Id', vendorRequestSchema?.forms?.inputForm?.id || '')
      formData.append('StatusCode', 0)
      formData.append('EditType', editTypeVal ? editTypeVal.join(',') : '')
      formData.append('VatRegistration', data.vatRegistration || '')
      formData.append('Building', data.building || '')
      formData.append('FloorRoom', data.floorRoom || '')
      formData.append('AddressNumber', data.addressNumber || '')
      formData.append('Moo', data.moo || '')
      formData.append('Soi', data.soi || '')
      formData.append('Village', data.village || '')
      formData.append('Road', data.road || '')
      formData.append('Location', data.location || '')
      formData.append('EncpTaxId', vendorRequestSchema?.forms?.rmsMessageInfo?.encpTaxId || '')
      formData.append('VendorCode', vendorRequestSchema?.forms?.rmsMessageInfo?.vendorCode || '')
      formData.append('WithholdingTaxType', data.withholdingTaxType || '')

      let c = 0
      FilesTables &&
        FilesTables?.forEach((item) => {
          const files = item?.value?.files

          if (Array.isArray(files) && files.length > 0) {
            files.forEach((file) => {
              formData.append(`AttachFilesList[${c}].DocumentId`, item.attId)
              formData.append(`AttachFilesList[${c}].DocumentTypeId`, item.id)
              formData.append(`AttachFilesList[${c}].DocumentType`, item.fileType)
              formData.append(`AttachFilesList[${c}].AttachFiles`, file.blobFile)
              c += 1
            })
          }
        })

      // c = 0
      FilesTablesEtc &&
        FilesTablesEtc?.forEach((item) => {
          const files = item?.value?.files

          if (Array.isArray(files) && files.length > 0) {
            files.forEach((file) => {
              formData.append(`AttachFilesList[${c}].DocumentId`, item.attId)
              formData.append(`AttachFilesList[${c}].DocumentTypeId`, item.id)
              formData.append(`AttachFilesList[${c}].DocumentType`, item.fileType)
              formData.append(`AttachFilesList[${c}].AttachFiles`, file.blobFile)
              c += 1
            })
          }
        })
      // filesImage &&
      //   filesImage?.forEach((element) => {
      //     console.log('element => ', element)
      //     if (element.id === null) {
      //       formData.append(`AttachFilesList[${c}].DocumentTypeId`, element.documentType)
      //       formData.append(`AttachFilesList[${c}].AttachFiles`, element.attachfile)

      //       c += 1
      //     }
      //   })

      delFilesImage &&
        delFilesImage?.forEach((element) => {
          formData.append('DeleteFileIds', element)
        })

      const resp = await saveRequestVendor(projectId, schema.requestId, formData, 'SendRequest')

      // console.log('resp => ', resp)

      if (resp.status == 200) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        // setVendorRequestSchema(resp)
        handleGetVendorRequestSchema(projectId, schema.requestId)
        setVendorRequestShowModal(false)
      } else {
        notification.open('error', {
          title: resp.message || SAVE_FAILED_MSG,
          duration: 5000,
        })
        handleGetVendorRequestSchema(projectId, schema.requestId)
      }
    } catch (e) {
      console.log('error handleOpenModalVendorRequest ', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || SAVE_FAILED_MSG,
        duration: 5000,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  const onChangeEdittypeMapFiles = (editTypeValue) => {
    console.log('onChangeEdittypeMapFiles => ', editTypeValue)
    const preservedVendorFileId = '1AB566CF-E0EF-4544-8832-28E573F6EC5F'
    const selectedEditTypes = Array.isArray(editTypeValue) ? editTypeValue.map(String) : []
    const selectedVatType = `${vatRegistrationVal ?? '0'}`
    const hasVatEditType = selectedEditTypes.includes('0')
    const currentFiles = cloneDeep(FilesTables ?? [])
    const fileCondition = vendorRequestSchema?.forms?.fileCondition ?? []
    const files = []

    fileCondition.forEach((item) => {
      const requestTypes = `${item?.requestType || ''}`.split(',').filter(Boolean)
      const hasVatType =
        item?.vatType !== null && item?.vatType !== undefined && item?.vatType !== ''
      const isMatchEditType = requestTypes.some((type) => selectedEditTypes.includes(type))
      const isMatchByNonVatEditType = requestTypes.some(
        (type) => type !== '0' && selectedEditTypes.includes(type)
      )
      const isMatchVatType =
        !hasVatEditType ||
        !hasVatType ||
        isMatchByNonVatEditType ||
        `${item?.vatType}` === selectedVatType
      const isPreservedFile = item?.id === preservedVendorFileId
      const isDuplicate = isPreservedFile
        ? files.some((file) => file.id === item.id && file.attId === item.attId)
        : files.some((file) => file.id === item.id)

      if (((isMatchEditType && isMatchVatType) || isPreservedFile) && !isDuplicate) {
        const existingFile = isPreservedFile
          ? currentFiles.find((file) => file.id === item.id && file.attId === item.attId)
          : currentFiles.find((file) => file.id === item.id)

        files.push({
          id: item?.id,
          fileName: item?.fileName,
          fileType: item?.fileType,
          isRequired: item?.isRequired,
          requestType: item?.requestType,
          vatType: item?.vatType,
          attId: existingFile ? existingFile?.attId : item?.attId,
          attFileName: existingFile ? existingFile?.attFileName : item?.attFileName,
          attFilePath: existingFile ? existingFile?.attFilePath : item?.attFilePath,
          value: existingFile ? existingFile?.value : null,
        })
      }
    })

    setFilesTables(files)
  }

  const mapFiles = (fileCondition) => {
    // console.log('mapFiles=> ', fileCondition)
    var mapFiles = []
    fileCondition.map((item, index) => {
      mapFiles.push({
        id: item?.id,
        fileName: item?.fileName,
        fileType: item?.fileType,
        isRequired: item?.isRequired,
        requestType: item?.requestType,
        vatType: item?.vatType,
        attId: item?.attId,
        attFileName: item?.attFileName,
        attFilePath: item?.attFilePath,
        value: null,
      })
    })

    return mapFiles
  }

  const onClickAddFilesEtc = () => {
    // console.log('filesTables => ', FilesTables?.length)

    if (!Array.isArray(FilesTables) || FilesTables?.length === 0) {
      notification.open('error', {
        title: 'ไม่สามารถเพิ่มไฟล์ สำเนาอื่นๆ ได้ กรุณาตรวจสอบเงื่อนไขการทำรายการ',
        duration: 5000,
      })
      return false
    }

    let filesTables = cloneDeep(FilesTablesEtc || [])

    const fileCondition = vendorRequestSchema?.forms?.fileCondition?.find(
      (item) => item.id === '1AB566CF-E0EF-4544-8832-28E573F6EC5F'
    )

    filesTables.push({
      id: '1AB566CF-E0EF-4544-8832-28E573F6EC5F',
      fileName: fileCondition?.fileName || 'สำเนาอื่น ๆ',
      fileType: fileCondition?.fileType || '6',
      isRequired: fileCondition?.isRequired || false,
      requestType: fileCondition?.requestType || '2,1,0',
      vatType: fileCondition?.vatType,
      attId: null,
      attFileName: null,
      attFilePath: null,
      value: null,
    })

    setFilesTablesEtc(filesTables)
  }

  const filterFiles = (val) => {
    const preservedVendorFileId = '1AB566CF-E0EF-4544-8832-28E573F6EC5F'
    const selectedVatType = `${val ?? '0'}`
    const selectedEditTypes = Array.isArray(editTypeVal) ? editTypeVal.map(String) : []
    const hasVatEditType = selectedEditTypes.includes('0')
    const currentFiles = cloneDeep(FilesTables ?? [])
    const fileCondition = vendorRequestSchema?.forms?.fileCondition ?? []
    const files = []

    fileCondition.forEach((item) => {
      const requestTypes = `${item?.requestType || ''}`.split(',').filter(Boolean)
      const hasVatType =
        item?.vatType !== null && item?.vatType !== undefined && item?.vatType !== ''
      const isMatchEditType = requestTypes.some((type) => selectedEditTypes.includes(type))
      const isMatchByNonVatEditType = requestTypes.some(
        (type) => type !== '0' && selectedEditTypes.includes(type)
      )
      const isMatchVatType =
        !hasVatEditType ||
        !hasVatType ||
        isMatchByNonVatEditType ||
        `${item?.vatType}` === selectedVatType
      const isPreservedFile = item?.id === preservedVendorFileId
      const isDuplicate = isPreservedFile
        ? files.some((file) => file.id === item.id && file.attId === item.attId)
        : files.some((file) => file.id === item.id)

      if (((isMatchEditType && isMatchVatType) || isPreservedFile) && !isDuplicate) {
        const existingFile = isPreservedFile
          ? currentFiles.find((file) => file.id === item.id && file.attId === item.attId)
          : currentFiles.find((file) => file.id === item.id)

        files.push({
          id: item?.id,
          fileName: item?.fileName,
          fileType: item?.fileType,
          isRequired: item?.isRequired,
          requestType: item?.requestType,
          vatType: item?.vatType,
          attId: existingFile ? existingFile?.attId : item?.attId,
          attFileName: existingFile ? existingFile?.attFileName : item?.attFileName,
          attFilePath: existingFile ? existingFile?.attFilePath : item?.attFilePath,
          value: existingFile ? existingFile?.value : null,
        })
      }
    })

    setFilesTables(files)
  }

  const setRowData = (item, files) => {
    let filesTables = cloneDeep(FilesTables || [])

    let newArr = []
    filesTables.map((i) => {
      if (i.id === item.id) {
        newArr.push({
          id: i.id,
          fileName: i.fileName,
          fileType: i.fileType,
          isRequired: i.isRequired,
          requestType: i?.requestType,
          vatType: i?.vatType,
          attId: i?.attId,
          attFileName: i?.attFileName,
          attFilePath: i?.attFilePath,
          // value: files?.files[0]?.blobFile || null,
          value: files || null,
        })
      } else {
        newArr.push(i)
      }
    })

    setFilesTables(newArr)

    // const formData = new FormData()
    // formData.append('DocumentTypeId', item?.fileType || '')

    // files.files &&
    //   files.files?.forEach((element) => {
    //     formData.append('AttachFiles', element.blobFile)
    //   })

    // handleVendorSaveFile(formData)
  }

  const setRowDataEtc = (item, files) => {
    let filesTables = cloneDeep(FilesTablesEtc || [])

    let newArr = []
    filesTables.map((i) => {
      if (i.id === item.id) {
        newArr.push({
          id: i.id,
          fileName: i.fileName,
          fileType: i.fileType,
          isRequired: i.isRequired,
          requestType: i?.requestType,
          attId: i?.attId,
          attFileName: i?.attFileName,
          attFilePath: i?.attFilePath,
          // value: files?.files[0]?.blobFile || null,
          value: files || null,
        })
      } else {
        newArr.push(i)
      }
    })

    // setFilesTables(newArr)
    setFilesTablesEtc(newArr)
  }

  return (
    <div>
      {schema?.note && (
        <Panel header={schema?.header} collapsible defaultExpanded bordered shaded>
          {isWithdrawNotMatch && (
            <>
              <Message
                type="warning"
                showIcon
                description={'แจ้งเตือน เงินงวดประมาณที่ขอเบิกไม่เท่ากับที่ขออนุมัติ'}
              />
              <br />
            </>
          )}

          <ControlLabel>{requiredFiled(schema.note.validators, schema.note.label)}</ControlLabel>
          <ErrorMessage error={errors[schema.note.name]} />
          <br />
          <Input
            name={schema.note.name}
            inputRef={register(isValidators(schema.note.validators))}
            rows={3}
            placeholder={schema.note.label}
            componentClass="textarea"
          />
          <hr />
          {isError && <Message showIcon type="error" description={isError} />}
          {disabledSendWithdraw && (
            <Message
              showIcon
              type="error"
              description={
                <div>
                  <span>
                    กรุณากรอก <b>รายงานสรุปประกอบการขออนุมัติเบิกเงิน</b> ในหน้า ขอเบิกเงินงวดที่{' '}
                    {nowRequestNo} เพื่อ{schema.buttonText}{' '}
                  </span>
                  <Link
                    to={{
                      pathname: `${pathname.proposal.projectManagement.withdrawRequest}`,
                      // pathname: `${pathname.proposal.projectManagement.withdrawRequest}/${projectId}`,
                      //search: `?${schema.requestId}`,
                    }}
                    onClick={() => {
                      sessionStorage.setItem('projectId', projectId)
                      sessionStorage.setItem('param', `?${schema.requestId}`)
                    }}
                  >
                    <u>ไปหน้าขอเบิกเงินงวดที่ {nowRequestNo}</u>
                  </Link>
                </div>
              }
            />
          )}
          {isWithdrawOver && (
            <Message
              showIcon
              type="error"
              description={
                <div>
                  <span>
                    ยอดเงินที่ขอเบิกเกินจำนวนเงินที่งวดที่ตั้งไว้ (เกินมา{' '}
                    {parseFloat(isWithdrawOver).toFixed(2)} บาท) กรุณาแก้ไขยอดที่ต้องการเบิก
                    {/* ในหน้า ขอเบิกเงินงวดที่{' '}
                    {nowRequestNo} เพื่อ{schema.buttonText}{' '} */}
                  </span>
                  {/* <Link
                    to={{
                      pathname: `${pathname.proposal.projectManagement.withdrawRequest}/${projectId}`,
                      search: `?${schema.requestId}`,
                    }}
                  >
                    <u>ไปหน้าขอเบิกเงินงวดที่ {nowRequestNo}</u>
                  </Link> */}
                </div>
              }
            />
          )}

          {isSaveWithdrawPlan && (
            <Message
              showIcon
              type="error"
              description={
                <div>
                  <span>
                    กรุณาบันทึกรายการเบิกจ่ายตามแผนงบประมาณก่อน โดยคลิกที่ปุ่ม “แก้ไข”
                    ในตารางงวดเบิกจ่าย
                  </span>
                </div>
              }
            />
          )}

          {!bankInformation?.isDisabled && (
            <Message
              showIcon
              type="error"
              description={
                <div>
                  <span>{bankInformation?.message}</span>
                </div>
              }
            />
          )}

          {schema?.alert && <CustomMessages datas={schema?.alert?.values} />}

          {/* {console.log('vendorRequestSchema => ', vendorRequestSchema)} */}

          {vendorRequestSchema?.messageProceed && (
            <Message
              type="warning"
              description={
                <div dangerouslySetInnerHTML={{ __html: vendorRequestSchema?.messageProceed }} />
              }
              style={{ marginBottom: 10 }}
            />
          )}

          <ApproverList
            approveType={4}
            projectversionId={projectId}
            disabled={
              disabledSendWithdraw ||
              isWithdrawOver ||
              isSaveWithdrawPlan ||
              !bankInformation?.isDisabled ||
              schema?.alert?.disabled ||
              vendorRequestSchema?.buttonWithdrawStatus
            }
            style={{ marginRight: 10 }}
            buttontext={'ตรวจสอบสายอนุมัติและ' + schema.buttonText}
            isLoading={isLoading}
            fetchButton={(disabled) => (
              <Button
                style={{ width: 'auto', marginRight: 20, marginBottom: 10 }}
                // appearance="ghost"
                color="rgb(45, 168, 136)"
                appearance="primary"
                onClick={handleSubmit(onSubmit)}
                // || isAuditBreak
                // disabled={vendorRequestSchema?.buttonWithdrawStatus}
                disabled={
                  disabledSendWithdraw ||
                  isWithdrawOver ||
                  isSaveWithdrawPlan ||
                  !bankInformation?.isDisabled ||
                  schema?.alert?.disabled ||
                  disabled
                }
              >
                {schema.buttonText}
              </Button>
            )}
          />

          {vendorRequestSchema?.forms?.buttons?.buttonMain && (
            <Button
              color="blue"
              onClick={() => {
                handleOpenModalVendorRequest()
              }}
              disabled={vendorRequestSchema?.forms?.buttons?.buttonMainDisabled}
              style={{ width: 'auto', marginRight: 10 }}
            >
              {vendorRequestSchema?.forms?.buttons?.buttonMain}
              {/* {'ตรวจสอบคำร้องขอแก้ไข'} */}
            </Button>
          )}

          {!disableSendBack && (
            <Button
              style={{ width: 'auto' }}
              // appearance="ghost"
              color="rgb(45, 168, 136)"
              appearance="primary"
              onClick={handleSubmit(onSubmitSendBack)}
            >
              {'ส่งให้กลับภาคีเพื่อขอแก้ไขปรับงวดเงิน'}
            </Button>
          )}
        </Panel>
      )}

      <Modal
        size={'lg'}
        show={vendorRequestShowModal}
        onHide={() => setVendorRequestShowModal(false)}
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>{vendorRequestSchema?.header || ''}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ marginLeft: 20, marginRight: 20, minHeight: 400 }}>
            <Panel expanded collapsible bordered>
              <div>
                {vendorRequestSchema?.forms?.inputForm.editType && (
                  <Row>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      {/* {!editTypeVal?.find((item) => item === '0' || item === '1') && (
                        <Message
                          type="error"
                          description={
                            vendorRequestSchema?.forms?.inputForm.editType?.validators.find(
                              (item) => item.type === 'REQUIRED'
                            )?.errorMessage || ''
                          }
                        />
                      )} */}

                      <ErrorMessage error={errors2.editType} />
                      <Controller
                        name={vendorRequestSchema?.forms?.inputForm.editType.name}
                        control={control2}
                        defaultValue={vendorRequestSchema?.forms?.inputForm.editType.value}
                        rules={isValidators(
                          vendorRequestSchema?.forms?.inputForm?.editType.validators
                        )}
                        render={(props) => {
                          return (
                            <CheckboxGroup
                              inline
                              name={vendorRequestSchema?.forms?.inputForm.editType.name}
                              value={editTypeVal || []}
                              onChange={(value) => {
                                console.log(value)
                                setEditTypeVal(value)
                                props.onChange(value)
                                onChangeEdittypeMapFiles(value)
                                // if (value.length === 0) {
                                //   let newArr = []
                                //   vendorRequestSchema?.forms?.inputForm.editType.options.map(
                                //     (item, index) => {
                                //       newArr.push(item.value)
                                //     }
                                //   )
                                //   setEditTypeVal(newArr)
                                // }
                              }}
                            >
                              {vendorRequestSchema?.forms?.inputForm.editType.options.map(
                                (item, index) => {
                                  return (
                                    <Checkbox key={index} value={item.value}>
                                      {item.label}
                                    </Checkbox>
                                  )
                                }
                              )}
                            </CheckboxGroup>
                          )
                        }}
                      />
                    </Col>
                  </Row>
                )}
              </div>

              {editTypeVal?.find((item) => item === '2') && (
                <div>
                  <Row style={{ marginTop: 20 }}>
                    <Col xs={24} sm={24} md={12} lg={12}>
                      <ControlLabel
                        className={classNames(
                          isRequired(
                            vendorRequestSchema?.forms?.inputForm.withholdingTaxType?.validators
                          ) && 'required'
                        )}
                      >
                        {vendorRequestSchema?.forms?.inputForm.withholdingTaxType.label}
                      </ControlLabel>
                      <ErrorMessage error={errors2.withholdingTaxType} />
                      <Controller
                        name={vendorRequestSchema?.forms?.inputForm.withholdingTaxType.name}
                        control={control2}
                        defaultValue={
                          vendorRequestSchema?.forms?.inputForm.withholdingTaxType.value
                        }
                        rules={isValidators(
                          vendorRequestSchema?.forms?.inputForm?.withholdingTaxType.validators
                        )}
                        render={(props) => {
                          return (
                            <SelectPicker
                              searchable={false}
                              data={
                                vendorRequestSchema?.forms?.inputForm?.withholdingTaxType
                                  ?.options || []
                              }
                              // disabled={disabledValue.fromBudgetYear}
                              value={props.value}
                              block
                              onChange={(value) => {
                                props.onChange(value)
                                // handleChangeBudgetYear(schema.budgetYearEndOption.name, value)
                              }}
                            />
                          )
                        }}
                      />
                    </Col>
                  </Row>
                  {/* <Row style={{ marginTop: 20 }}>
                    <Col xs={24} sm={24} md={12} lg={12}>
                      <ControlLabel
                        className={classNames(
                          isRequired(
                            vendorRequestSchema?.forms?.inputForm.withholdingTaxType?.validators
                          ) && 'required'
                        )}
                      >
                        {vendorRequestSchema?.forms?.inputForm?.withholdingTaxType?.label}
                      </ControlLabel>
                      <ErrorMessage error={errors2.withholdingTaxType} />
                      <Controller
                        name={vendorRequestSchema?.forms?.inputForm.withholdingTaxType.name}
                        control={control2}
                        defaultValue={
                          vendorRequestSchema?.forms?.inputForm.withholdingTaxType.value
                        }
                        rules={isValidators(
                          vendorRequestSchema?.forms?.inputForm?.withholdingTaxType.validators
                        )}
                        render={(props) => {
                          return (
                            <SelectPicker
                              searchable={false}
                              data={
                                vendorRequestSchema?.forms?.inputForm?.vatRegistration?.options ||
                                []
                              }
                              // disabled={disabledValue.fromBudgetYear}
                              value={props.value}
                              block
                              onChange={(value) => {
                                props.onChange(value)
                                // handleChangeBudgetYear(schema.budgetYearEndOption.name, value)
                              }}
                            />
                          )
                        }}
                      />
                    </Col>
                  </Row> */}
                </div>
              )}

              {editTypeVal?.find((item) => item === '0') && (
                <div>
                  <Row style={{ marginTop: 20 }}>
                    <Col xs={24} sm={24} md={12} lg={12}>
                      <ControlLabel
                        className={classNames(
                          isRequired(
                            vendorRequestSchema?.forms?.inputForm.vatRegistration?.validators
                          ) && 'required'
                        )}
                      >
                        {vendorRequestSchema?.forms?.inputForm.vatRegistration.label}
                      </ControlLabel>
                      <ErrorMessage error={errors2.vatRegistration} />
                      <Controller
                        name={vendorRequestSchema?.forms?.inputForm.vatRegistration.name}
                        control={control2}
                        defaultValue={vendorRequestSchema?.forms?.inputForm.vatRegistration.value}
                        rules={isValidators(
                          vendorRequestSchema?.forms?.inputForm?.vatRegistration.validators
                        )}
                        render={(props) => {
                          return (
                            <SelectPicker
                              searchable={false}
                              data={
                                vendorRequestSchema?.forms?.inputForm?.vatRegistration?.options ||
                                []
                              }
                              // disabled={disabledValue.fromBudgetYear}
                              value={props.value}
                              block
                              onChange={(value) => {
                                setVatRegistrationVal(value)
                                props.onChange(value)
                                filterFiles(value)
                                // handleChangeBudgetYear(schema.budgetYearEndOption.name, value)
                              }}
                            />
                          )
                        }}
                      />
                    </Col>
                  </Row>
                </div>
              )}

              {editTypeVal?.find((item) => item === '3') && (
                <div>
                  <Row style={{ marginTop: 20 }}>
                    <Col xs={24} sm={24} md={12} lg={12}>
                      <ControlLabel
                        className={classNames(
                          isRequired(vendorRequestSchema?.forms?.inputForm.isExcept?.validators) &&
                            'required'
                        )}
                      >
                        {vendorRequestSchema?.forms?.inputForm.isExcept.label}
                      </ControlLabel>
                      <ErrorMessage error={errors2.isExcept} />
                      <Controller
                        name={vendorRequestSchema?.forms?.inputForm.isExcept.name}
                        control={control2}
                        defaultValue={vendorRequestSchema?.forms?.inputForm.isExcept.value}
                        rules={isValidators(
                          vendorRequestSchema?.forms?.inputForm?.isExcept.validators
                        )}
                        render={(props) => {
                          return (
                            <SelectPicker
                              searchable={false}
                              data={vendorRequestSchema?.forms?.inputForm?.isExcept?.options || []}
                              // disabled={disabledValue.fromBudgetYear}
                              value={props.value}
                              block
                              onChange={(value) => {
                                props.onChange(value)
                                // handleChangeBudgetYear(schema.budgetYearEndOption.name, value)
                              }}
                            />
                          )
                        }}
                      />
                    </Col>
                  </Row>
                </div>
              )}

              {editTypeVal?.find((item) => item === '1') && (
                <div>
                  <Row style={{ marginTop: 20 }}>
                    {vendorRequestSchema?.forms?.inputForm.building && (
                      <Col xs={24} sm={24} md={18} lg={18}>
                        <ControlLabel
                          className={classNames(
                            isRequired(
                              vendorRequestSchema?.forms?.inputForm.building?.validators
                            ) && 'required'
                          )}
                        >
                          {vendorRequestSchema?.forms?.inputForm.building.label}
                        </ControlLabel>
                        <ErrorMessage error={errors2.building} />
                        <Input
                          placeholder={vendorRequestSchema?.forms?.inputForm.building.label}
                          defaultValue={vendorRequestSchema?.forms?.inputForm.building.value}
                          name={vendorRequestSchema?.forms?.inputForm.building.name}
                          inputRef={register2(
                            isValidators(vendorRequestSchema?.forms?.inputForm.building.validators)
                          )}
                        />
                      </Col>
                    )}

                    {vendorRequestSchema?.forms?.inputForm?.floorRoom && (
                      <Col xs={24} sm={24} md={6} lg={6}>
                        <ControlLabel
                          className={classNames(
                            isRequired(
                              vendorRequestSchema?.forms?.inputForm?.floorRoom.validators
                            ) && 'required'
                          )}
                        >
                          {vendorRequestSchema?.forms?.inputForm?.floorRoom.label}
                        </ControlLabel>
                        <ErrorMessage error={errors2.floorRoom} />
                        <Input
                          placeholder={vendorRequestSchema?.forms?.inputForm?.floorRoom.label}
                          defaultValue={vendorRequestSchema?.forms?.inputForm?.floorRoom.value}
                          name={vendorRequestSchema?.forms?.inputForm?.floorRoom.name}
                          inputRef={register2(
                            isValidators(
                              vendorRequestSchema?.forms?.inputForm?.floorRoom.validators
                            )
                          )}
                        />
                      </Col>
                    )}
                  </Row>

                  <Row style={{ marginTop: 10 }}>
                    {vendorRequestSchema?.forms?.inputForm?.addressNumber && (
                      <Col xs={24} sm={24} md={5} lg={5}>
                        <ControlLabel
                          className={classNames(
                            isRequired(
                              vendorRequestSchema?.forms?.inputForm?.addressNumber.validators
                            ) && 'required'
                          )}
                        >
                          {vendorRequestSchema?.forms?.inputForm?.addressNumber.label}
                        </ControlLabel>
                        <ErrorMessage error={errors2.addressNumber} />
                        <Input
                          placeholder={vendorRequestSchema?.forms?.inputForm?.addressNumber.label}
                          defaultValue={vendorRequestSchema?.forms?.inputForm?.addressNumber.value}
                          name={vendorRequestSchema?.forms?.inputForm?.addressNumber.name}
                          inputRef={register2(
                            isValidators(
                              vendorRequestSchema?.forms?.inputForm?.addressNumber.validators
                            )
                          )}
                        />
                      </Col>
                    )}

                    {vendorRequestSchema?.forms?.inputForm?.moo && (
                      <Col xs={24} sm={24} md={3} lg={3}>
                        <ControlLabel
                          className={classNames(
                            isRequired(vendorRequestSchema?.forms?.inputForm?.moo.validators) &&
                              'required'
                          )}
                        >
                          {vendorRequestSchema?.forms?.inputForm?.moo.label}
                        </ControlLabel>
                        <ErrorMessage error={errors2.moo} />
                        <Input
                          placeholder={vendorRequestSchema?.forms?.inputForm?.moo.label}
                          defaultValue={vendorRequestSchema?.forms?.inputForm?.moo.value}
                          name={vendorRequestSchema?.forms?.inputForm?.moo.name}
                          inputRef={register2(
                            isValidators(vendorRequestSchema?.forms?.inputForm?.moo.validators)
                          )}
                        />
                      </Col>
                    )}

                    {vendorRequestSchema?.forms?.inputForm?.soi && (
                      <Col xs={24} sm={24} md={8} lg={8}>
                        <ControlLabel
                          className={classNames(
                            isRequired(vendorRequestSchema?.forms?.inputForm?.soi.validators) &&
                              'required'
                          )}
                        >
                          {vendorRequestSchema?.forms?.inputForm?.soi.label}
                        </ControlLabel>
                        <ErrorMessage error={errors2.soi} />
                        <Input
                          placeholder={vendorRequestSchema?.forms?.inputForm?.soi.label}
                          defaultValue={vendorRequestSchema?.forms?.inputForm?.soi.value}
                          name={vendorRequestSchema?.forms?.inputForm?.soi.name}
                          inputRef={register2(
                            isValidators(vendorRequestSchema?.forms?.inputForm?.soi.validators)
                          )}
                        />
                      </Col>
                    )}

                    {vendorRequestSchema?.forms?.inputForm?.village && (
                      <Col xs={24} sm={24} md={8} lg={8}>
                        <ControlLabel
                          className={classNames(
                            isRequired(vendorRequestSchema?.forms?.inputForm?.village.validators) &&
                              'required'
                          )}
                        >
                          {vendorRequestSchema?.forms?.inputForm?.village.label}
                        </ControlLabel>
                        <ErrorMessage error={errors2.village} />
                        <Input
                          placeholder={vendorRequestSchema?.forms?.inputForm?.village.label}
                          defaultValue={vendorRequestSchema?.forms?.inputForm?.village.value}
                          name={vendorRequestSchema?.forms?.inputForm?.village.name}
                          inputRef={register2(
                            isValidators(vendorRequestSchema?.forms?.inputForm?.village.validators)
                          )}
                        />
                      </Col>
                    )}
                  </Row>

                  <Row style={{ marginTop: 10 }}>
                    {vendorRequestSchema?.forms?.inputForm?.road && (
                      <Col xs={24} sm={24} md={8} lg={8}>
                        <ControlLabel
                          className={classNames(
                            isRequired(vendorRequestSchema?.forms?.inputForm?.road.validators) &&
                              'required'
                          )}
                        >
                          {vendorRequestSchema?.forms?.inputForm?.road.label}
                        </ControlLabel>
                        <ErrorMessage error={errors2.road} />
                        <Input
                          placeholder={vendorRequestSchema?.forms?.inputForm?.road.label}
                          defaultValue={vendorRequestSchema?.forms?.inputForm?.road.value}
                          name={vendorRequestSchema?.forms?.inputForm?.road.name}
                          inputRef={register2(
                            isValidators(vendorRequestSchema?.forms?.inputForm?.road.validators)
                          )}
                        />
                      </Col>
                    )}

                    {vendorRequestSchema?.forms?.inputForm?.location && (
                      <Col xs={24} sm={24} md={16} lg={16}>
                        <ControlLabel
                          className={classNames(
                            isRequired(
                              vendorRequestSchema?.forms?.inputForm?.location.validators
                            ) && 'required'
                          )}
                        >
                          {vendorRequestSchema?.forms?.inputForm?.location.label}
                        </ControlLabel>
                        <ErrorMessage error={errors2.location} />
                        <Controller
                          name={vendorRequestSchema?.forms?.inputForm?.location.name}
                          control={control2}
                          defaultValue={vendorRequestSchema?.forms?.inputForm?.location.value}
                          rules={isValidators(
                            vendorRequestSchema?.forms?.inputForm?.location.validators
                          )}
                          render={(props) => {
                            return (
                              <Cascader
                                size="lg"
                                block
                                menuWidth={180}
                                data={rmsLocation || []}
                                value={props.value}
                                onChange={(value) => {
                                  props.onChange(value)
                                }}
                                placeholder={vendorRequestSchema?.forms?.inputForm?.location.label}
                                // disabled={isSameAddress}
                              ></Cascader>
                            )
                          }}
                        />
                      </Col>
                    )}
                  </Row>
                </div>
              )}

              {vendorRequestSchema?.forms?.attachFiles && (
                <Panel expanded collapsible bordered style={{ marginTop: 10 }}>
                  <div>
                    <Row style={{ marginTop: 20 }}>
                      {/* <Col xs={24} sm={24} md={24} lg={24}>
                                      <ControlLabel
                                        className={classNames(
                                          isRequired(vendorRequestSchema?.forms?.attachFiles.validators) &&
                                            'required'
                                        )}
                                      >
                                        {vendorRequestSchema?.forms?.attachFiles.header}
                                      </ControlLabel>
                                      <ErrorMessage
                                        error={errors3[`${vendorRequestSchema?.forms?.attachFiles.name}`]}
                                      />
                                      <Controller
                                        key={`${vendorRequestSchema?.forms?.attachFiles.name}`}
                                        name={`${vendorRequestSchema?.forms?.attachFiles.name}`}
                                        control={control3}
                                        rules={isValidators(vendorRequestSchema?.forms?.attachFiles.validators)}
                                        defaultValue={''}
                                        render={(props) => {
                                          return (
                                            <>
                                              <p
                                                style={{ fontSize: 'small', color: 'red' }}
                                              >{`  *อัปโหลดไฟล์ ชนิดที่รองรับ : ${
                                                vendorRequestSchema?.forms?.attachFiles.fileType ||
                                                '.jpg, .jpeg, .png'
                                              } , ขนาดไฟล์ไม่เกิน ${
                                                vendorRequestSchema?.forms?.attachFiles.fileSize ||
                                                defaultMaxFileSize
                                              } MB`}</p>
                                              <Uploader
                                                accept={
                                                  vendorRequestSchema?.forms?.attachFiles.fileType ||
                                                  '.jpg, .jpeg, .png'
                                                }
                                                autoUpload={false}
                                                disabled={vendorRequestSchema?.forms?.attachFiles.disabled}
                                                fileListVisible={true}
                                                listType="picture-text"
                                                // fileList={props.value || []}
                                                fileList={fileList2 || []}
                                                multiple={false}
                                                onChange={(fileList) => {
                                                  if (isEmpty(fileList)) {
                                                    props.onChange(undefined)
                                                    setFileList2([])
                                                  } else {
                                                    let file = fileList[fileList.length - 1]
                                                    console.log('file upload', file)
                                                    if (
                                                      file?.blobFile?.size >
                                                      (vendorRequestSchema?.forms?.attachFiles.fileSize ||
                                                        defaultMaxFileSize) *
                                                        1024 *
                                                        1024
                                                    ) {
                                                      notification.open('error', {
                                                        title: `ขนาดไฟล์เกิน ${
                                                          vendorRequestSchema?.forms?.attachFiles.fileSize ||
                                                          defaultMaxFileSize
                                                        } MB`,
                                                        duration: 5000,
                                                      })
                                                      return
                                                    }
              
                                                    if (isImageOrPdf(file.blobFile.type)) {
                                                      let lastFile = [file]
                                                      setFileList2(lastFile)
                                                      // console.log('lastFile', lastFile)
                                                      props.onChange(lastFile)
                                                      setFileTypeError(false)
              
                                                      // props.onChange(fileList)
                                                      // setFileTypeError(false)
                                                    } else {
                                                      setFileTypeError(true)
                                                      notification.open('error', {
                                                        title:
                                                          'ชนิดที่รองรับ ' +
                                                            vendorRequestSchema?.forms?.attachFiles.fileType ||
                                                          '.jpg, .jpeg, .png',
                                                        duration: 5000,
                                                      })
                                                    }
                                                  }
                                                }}
                                                draggable
                                                style={{ marginBottom: 10 }}
                                              >
                                                <div>
                                                  <Icon size="2x" icon="upload2" />
                                                  <small className="uploder__text">{`   ${vendorRequestSchema?.forms?.attachFiles.description}`}</small>
                                                </div>
                                              </Uploader>
                                            </>
                                          )
                                        }}
                                      />
                                    </Col> */}
                      {/* <Col xs={24} sm={24} md={16} lg={16}>
                                      <ControlLabel
                                        className={classNames(
                                          isRequired(
                                            vendorRequestSchema?.forms?.attachFiles?.inputDocumentType?.validators
                                          ) && 'required'
                                        )}
                                      >
                                        {vendorRequestSchema?.forms?.attachFiles?.inputDocumentType?.label}
                                      </ControlLabel>
                                      <ErrorMessage
                                        error={
                                          errors3[
                                            `${vendorRequestSchema?.forms?.attachFiles?.inputDocumentType?.name}`
                                          ]
                                        }
                                      />
                                      <Controller
                                        name={vendorRequestSchema?.forms?.attachFiles?.inputDocumentType?.name}
                                        control={control3}
                                        defaultValue={
                                          vendorRequestSchema?.forms?.attachFiles?.inputDocumentType?.value
                                        }
                                        rules={isValidators(
                                          vendorRequestSchema?.forms?.attachFiles?.inputDocumentType?.validators
                                        )}
                                        render={(props) => {
                                          return (
                                            <SelectPicker
                                              searchable={false}
                                              data={
                                                vendorRequestSchema?.forms?.attachFiles?.inputDocumentType
                                                  ?.options || []
                                              }
                                              value={props.value}
                                              block
                                              onChange={(value) => {
                                                props.onChange(value)
                                              }}
                                            />
                                          )
                                        }}
                                      />
                                    </Col> */}
                      {/* <Col xs={24} sm={24} md={8} lg={8}>
                                      <Button
                                        block
                                        color="rgb(45, 168, 136)"
                                        appearance="primary"
                                        onClick={handleSubmit3(onSubmitVendorRequestFile)}
                                        disabled={vendorRequestSchema?.forms?.attachFiles?.buttonTextDisabled}
                                        style={{ marginTop: 25 }}
                                      >
                                        {vendorRequestSchema?.forms?.attachFiles?.buttonText}
                                      </Button>
                                    </Col> */}

                      <Col xs={24} sm={24} md={24} lg={24}>
                        <table width={'100%'} border={1} style={{ marginTop: 5 }}>
                          <thead>
                            <tr>
                              <th width="10%" style={{ textAlign: 'center' }}>
                                <p style={{ padding: 3 }}>ลำดับ</p>
                              </th>
                              <th width="55%" style={{ textAlign: 'center' }}>
                                <p style={{ padding: 3, display: 'flex' }}>
                                  เอกสาร
                                  {/*  <p style={{ color: 'red', marginLeft: 5 }}>(* สำคัญมาก)</p> */}
                                </p>
                              </th>
                              <th width="20%">
                                <p style={{ padding: 3 }}>แนบเอกสาร</p>
                              </th>
                              <th width="15%">
                                <p style={{ padding: 3 }}>#</p>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {FilesTables?.length > 0 ? (
                              FilesTables.map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td align="center">{index + 1}</td>
                                    <td>
                                      {item.isRequired ? (
                                        <>
                                          <p style={{ padding: 3, display: 'flex' }}>
                                            {`${item.fileName}  `}
                                            <p style={{ color: 'red' }}>* </p>
                                          </p>
                                        </>
                                      ) : (
                                        <>
                                          <p style={{ padding: 3 }}>{item.fileName}</p>
                                        </>
                                      )}
                                      <p
                                        style={{
                                          padding: 3,
                                          color: '#8080808f',
                                          fontSize: 12,
                                          marginTop: -3,
                                        }}
                                      >
                                        {item?.attFileName || ''}
                                      </p>
                                    </td>
                                    <td align="center">
                                      {!vendorRequestSchema?.forms?.attachFiles
                                        ?.buttonTextDisabled && (
                                        <div style={{ padding: 3 }}>
                                          <Controller
                                            name={`file_${item.id}_${index}`}
                                            control={control}
                                            defaultValue={
                                              !isEmpty(item.value) ? [item.value] : undefined
                                            }
                                            // rules={isValidators(attachmentSchema.validators)}
                                            render={(props) => {
                                              return (
                                                <Uploader
                                                  accept={
                                                    vendorRequestSchema?.forms?.attachFiles
                                                      .fileType || '.jpg, .jpeg, .png, .pdf'
                                                  }
                                                  draggable
                                                  autoUpload={false}
                                                  multiple={false}
                                                  disabled={
                                                    vendorRequestSchema?.forms?.attachFiles
                                                      ?.buttonTextDisabled || false
                                                  }
                                                  // listType="picture"
                                                  // renderFileInfo={() => null}
                                                  renderFileInfo={(file, fileElement) => {
                                                    return <div>File:</div>
                                                  }}
                                                  fileList={props.value || []}
                                                  style={{ marginTop: 12 }}
                                                  onChange={(fileList) => {
                                                    if (isEmpty(fileList)) {
                                                      props.onChange(undefined)

                                                      setRowData(item, {
                                                        files: undefined,
                                                      })
                                                    } else {
                                                      let files = []
                                                      files.push(fileList[fileList.length - 1])
                                                      props.onChange(files)

                                                      setRowData(item, {
                                                        files: files,
                                                      })
                                                    }
                                                  }}
                                                >
                                                  <button
                                                    className="upload__button"
                                                    style={{ marginTop: 0 }}
                                                  >
                                                    <Icon icon="upload" size="lg" />
                                                  </button>
                                                </Uploader>
                                              )
                                            }}
                                          />
                                        </div>
                                      )}
                                    </td>
                                    <td align="center">
                                      {item.attId && (
                                        <div style={{ padding: 3 }}>
                                          <ButtonGroup>
                                            <IconButton
                                              appearance="ghost"
                                              size="sm"
                                              icon={
                                                <Icon icon="eye" className="bt-gost-icon-radius" />
                                              }
                                              onClick={() => handlePreviewFile(item)}
                                            />
                                            <IconButton
                                              appearance="ghost"
                                              size="sm"
                                              icon={
                                                <Icon
                                                  icon="download"
                                                  className="bt-gost-icon-none-radius"
                                                />
                                              }
                                              onClick={() => handleDownloadFile(item)}
                                            />
                                            {!vendorRequestSchema?.forms?.attachFiles
                                              ?.buttonTextDisabled && (
                                              <IconButton
                                                appearance="ghost"
                                                size="sm"
                                                className="rs-btn-ghost-cancel"
                                                disabled={
                                                  vendorRequestSchema?.forms?.attachFiles
                                                    ?.buttonTextDisabled || false
                                                }
                                                icon={
                                                  <Icon
                                                    icon="trash"
                                                    className="bt-gost-icon-radius-cancel"
                                                  />
                                                }
                                                onClick={() => handleDeleteFile(item)}
                                              />
                                            )}
                                          </ButtonGroup>
                                        </div>
                                      )}
                                    </td>
                                  </tr>
                                )
                              })
                            ) : (
                              <>
                                <td colSpan={5} align="center">
                                  <p style={{ padding: 5 }}>...ไม่มีข้อมูลไฟล์แนบ...</p>
                                </td>
                              </>
                            )}

                            {FilesTablesEtc?.length > 0 &&
                              FilesTablesEtc.map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td align="center">{FilesTables?.length + index + 1}</td>
                                    <td>
                                      {item.isRequired ? (
                                        <>
                                          <p style={{ padding: 3, display: 'flex' }}>
                                            {`${item.fileName}  `}
                                            <p style={{ color: 'red' }}>* </p>
                                          </p>
                                        </>
                                      ) : (
                                        <>
                                          <p style={{ padding: 3 }}>{item.fileName}</p>
                                        </>
                                      )}
                                    </td>
                                    <td align="center">
                                      <div style={{ padding: 3 }}>
                                        <Controller
                                          name={`file_${item.id}_${index}`}
                                          control={control}
                                          defaultValue={
                                            !isEmpty(item.value) ? [item.value] : undefined
                                          }
                                          // rules={isValidators(attachmentSchema.validators)}
                                          render={(props) => {
                                            return (
                                              <Uploader
                                                accept={
                                                  vendorRequestSchema?.forms?.attachFiles
                                                    .fileType || '.jpg, .jpeg, .png, .pdf'
                                                }
                                                draggable
                                                autoUpload={false}
                                                multiple={false}
                                                disabled={
                                                  vendorRequestSchema?.forms?.attachFiles
                                                    ?.buttonTextDisabled || false
                                                }
                                                // listType="picture"
                                                // renderFileInfo={() => null}
                                                renderFileInfo={(file, fileElement) => {
                                                  return <div>File:</div>
                                                }}
                                                fileList={props.value || []}
                                                style={{ marginTop: 12 }}
                                                onChange={(fileList) => {
                                                  if (isEmpty(fileList)) {
                                                    props.onChange(undefined)

                                                    setRowDataEtc(item, {
                                                      files: undefined,
                                                    })
                                                  } else {
                                                    let files = []
                                                    files.push(fileList[fileList.length - 1])
                                                    props.onChange(files)

                                                    setRowDataEtc(item, {
                                                      files: files,
                                                    })
                                                  }
                                                }}
                                              >
                                                <button
                                                  className="upload__button"
                                                  style={{ marginTop: 0 }}
                                                >
                                                  <Icon icon="upload" size="lg" />
                                                </button>
                                              </Uploader>
                                            )
                                          }}
                                        />
                                      </div>
                                    </td>
                                    <td align="center">
                                      {/* {item.attId && (
                                                      <div style={{ padding: 3 }}>
                                                        <ButtonGroup>
                                                          <IconButton
                                                            appearance="ghost"
                                                            size="sm"
                                                            icon={
                                                              <Icon icon="eye" className="bt-gost-icon-radius" />
                                                            }
                                                            onClick={() => handlePreviewFile(item)}
                                                          />
                                                          <IconButton
                                                            appearance="ghost"
                                                            size="sm"
                                                            icon={
                                                              <Icon
                                                                icon="download"
                                                                className="bt-gost-icon-none-radius"
                                                              />
                                                            }
                                                            onClick={() => handleDownloadFile(item)}
                                                          />
                                                          {!vendorRequestSchema?.forms?.attachFiles
                                                            ?.buttonTextDisabled && (
                                                            <IconButton
                                                              appearance="ghost"
                                                              size="sm"
                                                              className="rs-btn-ghost-cancel"
                                                              disabled={
                                                                vendorRequestSchema?.forms?.attachFiles
                                                                  ?.buttonTextDisabled || false
                                                              }
                                                              icon={
                                                                <Icon
                                                                  icon="trash"
                                                                  className="bt-gost-icon-radius-cancel"
                                                                />
                                                              }
                                                              onClick={() => handleDeleteFile(item)}
                                                            />
                                                          )}
                                                        </ButtonGroup>
                                                      </div>
                                                    )} */}
                                    </td>
                                  </tr>
                                )
                              })}

                            {/* {vendorRequestSchema?.forms?.attachFiles?.values?.length > 0 ? (
                                            vendorRequestSchema?.forms?.attachFiles?.values?.map( */}
                            {/* {filesImage?.length > 0 ? (
                                            filesImage?.map((item, index) => {
                                              return (
                                                <tr>
                                                  <td align="center">{index + 1}</td>
                                                  <td>
                                                    <p style={{ padding: 3 }}>{item.fileName}</p>
                                                  </td>
                                                  <td>
                                                    <p style={{ padding: 3 }}>{item.documentTypeDesc}</p>
                                                  </td>
                                                  <td align="center">
                                                    <div style={{ padding: 3 }}>
                                                      <ButtonGroup>
                                                        <IconButton
                                                          appearance="ghost"
                                                          size="sm"
                                                          icon={
                                                            <Icon icon="eye" className="bt-gost-icon-radius" />
                                                          }
                                                          onClick={() => handlePreviewFile(item)}
                                                          // disabled={!item?.path}
                                                        />
                                                        <IconButton
                                                          appearance="ghost"
                                                          size="sm"
                                                          icon={
                                                            <Icon
                                                              icon="download"
                                                              className="bt-gost-icon-none-radius"
                                                            />
                                                          }
                                                          onClick={() => handleDownloadFile(item)}
                                                          // disabled={!item?.path}
                                                        />
                                                        {!vendorRequestSchema?.forms?.attachFiles
                                                          ?.buttonTextDisabled && (
                                                          <IconButton
                                                            appearance="ghost"
                                                            size="sm"
                                                            className="rs-btn-ghost-cancel"
                                                            icon={
                                                              <Icon
                                                                icon="trash"
                                                                className="bt-gost-icon-radius-cancel"
                                                              />
                                                            }
                                                            // disabled={filesImage.length == 1}
                                                            onClick={() => handleDeleteFile(item)}
                                                            // disabled={!item?.path}
                                                          />
                                                        )}
                                                      </ButtonGroup>
                                                    </div>
                                                  </td>
                                                </tr>
                                              )
                                            }) */}
                            {/* ) : ( */}
                            {/* <tr>
                                            <td colSpan={5} align="center">
                                              <p style={{ padding: 5 }}>...ไม่มีข้อมูลไฟล์แนบ...</p>
                                            </td>
                                          </tr> */}
                            {/* )} */}
                          </tbody>
                        </table>

                        <div style={{ textAlign: 'right', marginTop: 5 }}>
                          {!vendorRequestSchema?.forms?.attachFiles?.buttonTextDisabled && (
                            <Button
                              appearance="primary"
                              onClick={() => {
                                onClickAddFilesEtc()
                              }}
                              disabled={
                                vendorRequestSchema?.forms?.attachFiles?.buttonTextDisabled || false
                              }
                            >
                              เพิ่มไฟล์ สำเนาอื่น ๆ
                            </Button>
                          )}
                        </div>

                        {/* <table width={'100%'} border={1} style={{ marginTop: 8 }}>
                                        <thead>
                                          <tr>
                                            <th width="10%" style={{ textAlign: 'center' }}>
                                              <p style={{ padding: 3 }}>ลำดับ</p>
                                            </th>
                                            <th width="55%">
                                              <p style={{ padding: 3 }}>เอกสาร อื่นๆ</p>
                                            </th>
                                            <th width="20%">
                                              <p style={{ padding: 3 }}>แนบเอกสาร</p>
                                            </th>
                                            <th width="15%">
                                              <p style={{ padding: 3 }}>#</p>
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody></tbody>
                                      </table> */}
                      </Col>
                    </Row>
                  </div>
                </Panel>
              )}

              {/* {vendorRequestSchema?.forms?.attachFiles && (
                <Panel expanded collapsible bordered style={{ marginTop: 10 }}>
                  <div>
                    <Row style={{ marginTop: 20 }}>
                      <Col xs={24} sm={24} md={24} lg={24}>
                        <ControlLabel
                          className={classNames(
                            isRequired(vendorRequestSchema?.forms?.attachFiles.validators) &&
                              'required'
                          )}
                        >
                          {vendorRequestSchema?.forms?.attachFiles.header}
                        </ControlLabel>
                        <ErrorMessage
                          error={errors3[`${vendorRequestSchema?.forms?.attachFiles.name}`]}
                        />
                        <Controller
                          key={`${vendorRequestSchema?.forms?.attachFiles.name}`}
                          name={`${vendorRequestSchema?.forms?.attachFiles.name}`}
                          control={control3}
                          rules={isValidators(vendorRequestSchema?.forms?.attachFiles.validators)}
                          defaultValue={''}
                          render={(props) => {
                            return (
                              <>
                                <p
                                  style={{ fontSize: 'small', color: 'red' }}
                                >{`  *อัปโหลดไฟล์ ชนิดที่รองรับ : ${
                                  vendorRequestSchema?.forms?.attachFiles.fileType ||
                                  '.jpg, .jpeg, .png'
                                } , ขนาดไฟล์ไม่เกิน ${
                                  vendorRequestSchema?.forms?.attachFiles.fileSize ||
                                  defaultMaxFileSize
                                } MB`}</p>
                                <Uploader
                                  accept={
                                    vendorRequestSchema?.forms?.attachFiles.fileType ||
                                    '.jpg, .jpeg, .png'
                                  }
                                  autoUpload={false}
                                  disabled={vendorRequestSchema?.forms?.attachFiles.disabled}
                                  fileListVisible={true}
                                  listType="picture-text"
                                  fileList={fileList2 || []}
                                  multiple={false}
                                  onChange={(fileList) => {
                                    if (isEmpty(fileList)) {
                                      props.onChange(undefined)
                                      setFileList2([])
                                    } else {
                                      let file = fileList[fileList.length - 1]
                                      console.log('file upload', file)
                                      if (
                                        file?.blobFile?.size >
                                        (vendorRequestSchema?.forms?.attachFiles.fileSize ||
                                          defaultMaxFileSize) *
                                          1024 *
                                          1024
                                      ) {
                                        notification.open('error', {
                                          title: `ขนาดไฟล์เกิน ${
                                            vendorRequestSchema?.forms?.attachFiles.fileSize ||
                                            defaultMaxFileSize
                                          } MB`,
                                          duration: 5000,
                                        })
                                        return
                                      }

                                      if (isImageOrPdf(file.blobFile.type)) {
                                        let lastFile = [file]
                                        setFileList2(lastFile)
                                        props.onChange(lastFile)
                                        setFileTypeError(false)
                                      } else {
                                        setFileTypeError(true)
                                        notification.open('error', {
                                          title:
                                            'ชนิดที่รองรับ ' +
                                              vendorRequestSchema?.forms?.attachFiles.fileType ||
                                            '.jpg, .jpeg, .png',
                                          duration: 5000,
                                        })
                                      }
                                    }
                                  }}
                                  draggable
                                  style={{ marginBottom: 10 }}
                                >
                                  <div>
                                    <Icon size="2x" icon="upload2" />
                                    <small className="uploder__text">{`   ${vendorRequestSchema?.forms?.attachFiles.description}`}</small>
                                  </div>
                                </Uploader>
                              </>
                            )
                          }}
                        />
                      </Col>
                      <Col xs={24} sm={24} md={16} lg={16}>
                        <ControlLabel
                          className={classNames(
                            isRequired(
                              vendorRequestSchema?.forms?.attachFiles?.inputDocumentType?.validators
                            ) && 'required'
                          )}
                        >
                          {vendorRequestSchema?.forms?.attachFiles?.inputDocumentType?.label}
                        </ControlLabel>
                        <ErrorMessage
                          error={
                            errors3[
                              `${vendorRequestSchema?.forms?.attachFiles?.inputDocumentType?.name}`
                            ]
                          }
                        />
                        <Controller
                          name={vendorRequestSchema?.forms?.attachFiles?.inputDocumentType?.name}
                          control={control3}
                          defaultValue={
                            vendorRequestSchema?.forms?.attachFiles?.inputDocumentType?.value
                          }
                          rules={isValidators(
                            vendorRequestSchema?.forms?.attachFiles?.inputDocumentType?.validators
                          )}
                          render={(props) => {
                            return (
                              <SelectPicker
                                searchable={false}
                                data={
                                  vendorRequestSchema?.forms?.attachFiles?.inputDocumentType
                                    ?.options || []
                                }
                                value={props.value}
                                block
                                onChange={(value) => {
                                  props.onChange(value)
                                }}
                              />
                            )
                          }}
                        />
                      </Col>
                      <Col xs={24} sm={24} md={8} lg={8}>
                        <Button
                          block
                          color="rgb(45, 168, 136)"
                          appearance="primary"
                          onClick={handleSubmit3(onSubmitVendorRequestFile)}
                          disabled={vendorRequestSchema?.forms?.attachFiles?.buttonTextDisabled}
                          style={{ marginTop: 25 }}
                        >
                          {vendorRequestSchema?.forms?.attachFiles?.buttonText}
                        </Button>
                      </Col>

                      <Col xs={24} sm={24} md={24} lg={24}>
                        <table width={'100%'} border={1} style={{ marginTop: 8 }}>
                          <thead>
                            <tr>
                              <th width="10%" style={{ textAlign: 'center' }}>
                                <p style={{ padding: 3 }}>ลำดับ</p>
                              </th>
                              <th width="45%">
                                <p style={{ padding: 3 }}>{`ไฟล์`}</p>
                              </th>
                              <th width="25%">
                                <p style={{ padding: 3 }}>ประเภทเอกสาร</p>
                              </th>
                              <th width="20%">
                                <p style={{ padding: 3 }}>#</p>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {filesImage?.length > 0 ? (
                              filesImage?.map((item, index) => {
                                return (
                                  <tr>
                                    <td align="center">{index + 1}</td>
                                    <td>
                                      <p style={{ padding: 3 }}>{item.fileName}</p>
                                    </td>
                                    <td>
                                      <p style={{ padding: 3 }}>{item.documentTypeDesc}</p>
                                    </td>
                                    <td align="center">
                                      <div style={{ padding: 3 }}>
                                        <ButtonGroup>
                                          <IconButton
                                            appearance="ghost"
                                            size="sm"
                                            icon={
                                              <Icon icon="eye" className="bt-gost-icon-radius" />
                                            }
                                            onClick={() => handlePreviewFile(item)}
                                          />
                                          <IconButton
                                            appearance="ghost"
                                            size="sm"
                                            icon={
                                              <Icon
                                                icon="download"
                                                className="bt-gost-icon-none-radius"
                                              />
                                            }
                                            onClick={() => handleDownloadFile(item)}
                                          />
                                          {!vendorRequestSchema?.forms?.attachFiles
                                            ?.buttonTextDisabled && (
                                            <IconButton
                                              appearance="ghost"
                                              size="sm"
                                              className="rs-btn-ghost-cancel"
                                              icon={
                                                <Icon
                                                  icon="trash"
                                                  className="bt-gost-icon-radius-cancel"
                                                />
                                              }
                                              onClick={() => handleDeleteFile(item)}
                                            />
                                          )}
                                        </ButtonGroup>
                                      </div>
                                    </td>
                                  </tr>
                                )
                              })
                            ) : (
                              <tr>
                                <td colSpan={4} align="center">
                                  <p style={{ padding: 3 }}>...ไม่มีข้อมูลไฟล์แนบ...</p>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </Col>
                    </Row>
                  </div>
                </Panel>
              )} */}
            </Panel>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {/* {vendorRequestSchema?.forms?.buttons?.buttonSave && (
            <Button onClick={handleSubmit2(onSubmitVendorRequest)} appearance="primary">
              {vendorRequestSchema?.forms?.buttons?.buttonSave}
            </Button>
          )} */}

          {vendorRequestSchema?.forms?.buttons?.buttonReqEdit && (
            <Button
              // onClick={() => {
              //   handleSendRequestEditVendorRequest()
              // }}
              onClick={handleSubmit2(handleSendRequestEditVendorRequest)}
              appearance="primary"
            >
              {vendorRequestSchema?.forms?.buttons?.buttonReqEdit}
            </Button>
          )}

          {vendorRequestSchema?.forms?.buttons?.buttonCancel && (
            <Button
              onClick={() => {
                setVendorRequestShowModal(false)
              }}
              appearance="subtle"
            >
              {vendorRequestSchema?.forms?.buttons?.buttonCancel}
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <ConfirmWidget
        size={'sm'}
        title={`ยืนยันการ${schema.buttonText}`}
        show={showConfirm}
        detail={`กรุณายืนยันการ${schema.buttonText}`}
        onCancle={() => setShowConfirm(false)}
        onConfirm={() => handleCallService()}
      >
        {isWithdrawNotMatch && (
          <>
            <Message
              type="warning"
              showIcon
              description={'แจ้งเตือน เงินงวดประมาณที่ขอเบิกไม่เท่ากับที่ขออนุมัติ'}
            />
            <br />
          </>
        )}
      </ConfirmWidget>

      <ConfirmWidget
        size={'sm'}
        title={`ยืนยันการส่งกลับภาคี`}
        show={showConfirmSendBack}
        detail={`กรุณายืนยันการส่งกลับภาคี`}
        onCancle={() => setShowConfirmSendBack(false)}
        onConfirm={() => handleCallServiceSendBack()}
      />
    </div>
  )
}
